import { render, staticRenderFns } from "./StandardValuePaymentStep.vue?vue&type=template&id=42bf2642&scoped=true"
import script from "./StandardValuePaymentStep.vue?vue&type=script&lang=js"
export * from "./StandardValuePaymentStep.vue?vue&type=script&lang=js"
import style0 from "./StandardValuePaymentStep.vue?vue&type=style&index=0&id=42bf2642&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf2642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bf2642')) {
      api.createRecord('42bf2642', component.options)
    } else {
      api.reload('42bf2642', component.options)
    }
    module.hot.accept("./StandardValuePaymentStep.vue?vue&type=template&id=42bf2642&scoped=true", function () {
      api.rerender('42bf2642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/StandardValuePaymentStep.vue"
export default component.exports